import React from 'react';
import { useIntl } from 'react-intl';
import { faLinkSlash } from '@fortawesome/pro-light-svg-icons/faLinkSlash';
import { TypedMemo } from '../common/types';
import { TeamAcceptStateCard } from './TeamAcceptStateCard';

/** Design q4: no token in the URL fragment and none in session storage. */
const TeamAcceptIncompleteLinkComponent: React.FC = () => {
  const intl = useIntl();

  return (
    <TeamAcceptStateCard
      tone="neutral"
      icon={faLinkSlash}
      title={intl.formatMessage({
        id: 'app.sml.team.accept.incomplete.title',
        defaultMessage: 'This link is not complete.',
      })}
      lead={intl.formatMessage({
        id: 'app.sml.team.accept.missing',
        defaultMessage: 'This invite link is not complete. Open the link from the email again.',
      })}
    />
  );
};

export const TeamAcceptIncompleteLink = TypedMemo(TeamAcceptIncompleteLinkComponent);
